<template>
  <v-dialog
    v-model="enableDialog"
    persistent
    width="600"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <validation-observer ref="changePasswordFormValidator">
      <v-form>
        <v-card flat>
          <v-toolbar flat>
            <v-toolbar-title>パスワード変更</v-toolbar-title>
          </v-toolbar>
          <v-divider />
          <v-card-text>
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  name="現在のパスワード"
                  class="requiredMark"
                >
                  <v-text-field
                    v-model="forms.current_password"
                    :error-messages="errors"
                    :append-icon="showOldPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    dense
                    label="現在のパスワード"
                    autocomplete="current-password"
                    hide-details="auto"
                    outlined
                    prepend-icon="mdi-lock"
                    placeholder=""
                    persistent-placeholder
                    :type="showOldPassword ? 'text' : 'password'"
                    @click:append="showOldPassword = !showOldPassword"
                  />
                </validation-provider>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text>
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  class="requiredMark"
                  name="新パスワード"
                  rules="required|password"
                  vid="password"
                >
                  <v-text-field
                    v-model="forms.password"
                    :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :error-messages="errors"
                    :type="showNewPassword ? 'text' : 'password'"
                    dense
                    label="新パスワード"
                    autocomplete="new-password"
                    hide-details="auto"
                    outlined
                    prepend-icon="mdi-lock"
                    placeholder=""
                    persistent-placeholder
                    @click:append="showNewPassword = !showNewPassword"
                  />
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|confirmed:password"
                  name="新パスワード（確認用）"
                >
                  <v-text-field
                    v-model="forms.password_confirmation"
                    :error-messages="errors"
                    dense
                    :append-icon="showNewPasswordConfirmation ? 'mdi-eye' : 'mdi-eye-off'"
                    label="新パスワード（確認用）"
                    autocomplete="new-password"
                    outlined
                    prepend-icon="mdi-lock"
                    persistent-placeholder
                    :type="showNewPasswordConfirmation ? 'text' : 'password'"
                    @click:append="showNewPasswordConfirmation = !showNewPasswordConfirmation"
                  />
                </validation-provider>
              </v-col>
            </v-row>
            <v-row
              align="center"
              justify="center"
              class="fill-height"
            >
              <v-card outlined>
                <v-card-text>
                  <div class="subtitle-2">
                    半角8~12文字 英小文字・大文字・数字をそれぞれ1種類以上
                  </div>
                </v-card-text>
              </v-card>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn
              @click="closeButtonClickEvent"
            >
              閉じる
            </v-btn>
            <v-btn
              color="primary"
              @click="registerButtonClickEvent"
            >
              更新
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </validation-observer>
  </v-dialog>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  name: 'OrderChangePasswordDialog',
  components: {},
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    }
  },
  data() {
    return {
      showOldPassword: false,
      showNewPassword: false,
      showNewPasswordConfirmation: false,
      forms: {
        current_password: null,
        password: null,
        password_confirmation: null,
      }
    }
  },
  computed: {},
  watch: {
    enableDialog: function() {
      this.$nextTick(() => this.$refs.changePasswordFormValidator.reset())
      Object.assign(this.$data.forms, this.$options.data().forms);
    }
  },
  created() {
  },
  methods: {
    ...mapActions('DriverMe', {
      updatePassword: 'update',
    }),
    closeButtonClickEvent () {
      this.$emit('closeEvent')
    },
    registerButtonClickEvent () {
      let $self = this
      this.$refs.changePasswordFormValidator.validate().then((result) => {
        if(result){
          $self.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation () {
      this.updatePassword({params: this.forms}).then(() => {
        this.$emit('registerEvent')
      })
    },
  }
}
</script>

<style scoped>

</style>
